import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore, useUser, callAPI, usePage } from "../../../Utils/utils";
import { blog_category_page_labels } from "../../../Constants/Labels";
import { select_store_message } from "../../../Constants/Messages";
import "./BlogCategoryList.css";

export default function BlogCategoryList({ mode, searchResult, loader }) {
  const navigate = useNavigate();
  const { store } = useStore();
  const storeId = store?.id;
  const { user } = useUser();
  const { setPage } = usePage();
  const [blogCategoryOrder, setBlogCategoryOrder] = useState([]);

  useEffect(() => {
    if (searchResult && searchResult.length > 0) {
      setBlogCategoryOrder(searchResult);
    } else {
        setBlogCategoryOrder([]);
    }
  }, [searchResult]);

  const editBlogCategory = (id) => {
      navigate(`/admin/blog-category/edit/${id}`);
  };

  return (
    <>
      <div className={loader ? "loderHide" : "loderShow"}>
        {!storeId || storeId === "Admin" ? (
          <p className="text-center">{select_store_message?.select_store}</p>
        ) : (
          <div>
            {!searchResult || searchResult.length === 0 ? (
              <div className="card">
                <div className="card-body defaultText">
                  <p className="text-center">No blog categories found.</p>
                </div>
              </div>
            ) : (
              <div className="tableOutline">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="col-lg-6">
                        {
                          blog_category_page_labels?.blog_category_page_table_head_labels
                            ?.title
                        }
                      </th>
                      <th className="col-lg-5">
                        {
                          blog_category_page_labels?.blog_category_page_table_head_labels
                            ?.status
                        }
                      </th>

                      <th className="col-lg-1">
                        {
                          blog_category_page_labels?.blog_category_page_table_head_labels
                            ?.action
                        }
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {blogCategoryOrder?.map((Category) => {
                      const status =
                        Category.status === "active" ? "Active" : "Inactive";
                      return (
                        <tr
                          key={Category.blog_category_id || Category.id}
                        >
                          <td
                            onClick={() => editBlogCategory(Category.blog_category_id || Category.id)}
                            className="nameCol"
                          >
                            {Category.name}
                          </td>
                          <td>{status}</td>
                            <td>
                              <span
                                className="mdi mdi-account-edit icon"
                                onClick={() =>
                                  editBlogCategory(Category.blog_category_id || Category.id)
                                }
                              ></span>
                            </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
